import React from "react";

const SvgTable = props => (
  <svg viewBox="0 0 512 512" {...props} width="1em" height="1em">
    <path d="M489.739 0H22.261C9.984 0 0 9.984 0 22.261v467.478C0 502.016 9.984 512 22.25 512h467.489c12.277 0 22.261-9.984 22.261-22.261V22.261C512 9.984 502.016 0 489.739 0zM178.087 356.174V244.87h155.826v111.304H178.087zm155.826 22.261v111.304H178.087V378.435h155.826zm0-267.131v111.304H178.087V111.304h155.826zm155.826 0v111.304H356.174V111.304h133.565zM155.826 222.609H22.261V111.304h133.565v111.305zM22.261 244.87h133.565v111.304H22.261V244.87zm333.913 0h133.565v111.304H356.174V244.87zM489.739 22.261v66.783H22.261V22.261h467.478zM22.261 378.435h133.565v111.304H22.261V378.435zm333.913 111.304V378.435h133.565v111.304H356.174z" />
  </svg>
);

export default SvgTable;
